import { EndOfJourneyQuestion } from '../../lib/types/models/end-of-journey-template/end-of-journey-question'
import {
  EndOfJourneyQuestionInput,
  EndOfJourneyQuestionRequestInput
} from '../../lib/types/models/end-of-journey-template/end-of-journey-question-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createEndOfJourneyQuestion(
  data: EndOfJourneyQuestionRequestInput
): Promise<EndOfJourneyQuestion> {
  const { templateId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API['end-of-journey-templates'].createQuestion.url, { id: templateId }))
    .post<EndOfJourneyQuestion, EndOfJourneyQuestionInput>(rest)
}
